module.exports = __webpack_public_path__ + "static/media/44617884_2199888163419696_3822636200426995712_o.c93bf514.jpg";